import React from 'react';
import { RunnerPageDescription } from '@Client/runner.directives/common/PageDescription';
import { CreationHubPicker } from './CreationHubPicker';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { getService } from '@Client/runner.hooks/useService';
import { BrandColor } from '@Shared.Angular/@types/brandColor';

export const CreateProcedureHubPage = () => {
  const $state = getService('$state');
  const appConfig = getService('APP_CONFIG');
  const isExtensionInstalled =
    getService('proceduresService').IsProcedureRecordingExtensionInstalled;
  const missingExtensionMessage =
    "Requires the Flowingly recorder extension - available from most browsers' extension stores.";
  return (
    <div className="create-procedure-hub-page creation-hub-page">
      <RunnerPageDescription
        showText={false}
        backLinkText="Back"
        backLinkState={STATE_MAPPINGS.creationHub}
      />
      <CreationHubPicker
        title="New Standard Operating Procedure"
        description="Pick how you'd like to create your SOP."
        groups={[
          {
            title: 'Build Manually',
            color: BrandColor.Grey,
            label: 'No AI',
            items: [
              {
                iconClass: 'fa-pen-line',
                title: 'Build from Scratch',
                description:
                  'Upload your own images and add descriptions manually, with full control to document every step of your processes.',
                color: BrandColor.Grey,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcedureFromScratch);
                }
              },
              {
                iconClass: 'fa-aperture',
                title: 'Capture in Browser',
                description: isExtensionInstalled
                  ? 'Capture tasks automatically with the Flowingly browser recorder extension in Chrome or Edge.'
                  : missingExtensionMessage,
                color: BrandColor.Grey,
                isDisabled: !isExtensionInstalled,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcedureFromExtension);
                }
              }
            ]
          },
          {
            title: 'Build With AI',
            color: BrandColor.PrimaryBlue,
            label: 'AI',
            iconClass: 'fa-sparkles',
            items: [
              {
                iconClass: 'fa-video',
                title: 'Record Your Screen with AI',
                description:
                  'Record your screen and voice live with the desktop recorder, and AI will extract key steps to generate a structured SOP.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcedureFromRecording);
                }
              },
              appConfig.enableProcedureAiEnhancement && {
                iconClass: 'fa-aperture',
                title: 'Capture in Browser with AI',
                description: isExtensionInstalled
                  ? 'Capture tasks automatically with the Flowingly browser recorder extension, while AI enhances your titles and descriptions.'
                  : missingExtensionMessage,
                color: isExtensionInstalled
                  ? BrandColor.PrimaryBlue
                  : BrandColor.Grey,
                isDisabled: !isExtensionInstalled,
                onClick: () => {
                  $state.go(
                    STATE_MAPPINGS.creationHubProcedureFromExtensionWithAi
                  );
                }
              },
              {
                iconClass: 'fa-upload',
                title: 'Generate from Video',
                description:
                  'Upload an existing video, and AI will extract key steps to generate a structured SOP.',
                color: BrandColor.PrimaryBlue,
                onClick: () => {
                  $state.go(STATE_MAPPINGS.creationHubProcedureFromVideo);
                }
              }
            ]
          }
        ]}
      />
    </div>
  );
};
